import React from 'react'
import Background from 'components/Background'

const CreateCodeSetViewBackground = () => (
  <Background height="36vh" />
)
export default CreateCodeSetViewBackground
